<template>
  <div>
    <template v-if="type === 'events'">
      <div class="w3-row" style="margin:0 4px 8px;">
        <div class="w3-col" :class="showMapOption ? 's6 m8' : 's10 m10'">
          <input class="w3-input w3-border" :class="searchText !== '' ? 'activeSearch' : ''" placeholder="Search..." v-model="searchText" @keyup="searchByText()" aria-label="search input" />
        </div>
        <template v-if="!filterType || filterType !== 'category'">
          <div class="w3-col s3 m2">
            <select class="w3-select w3-border" style="height:42px;" v-model="searchOption" @change="setSearchFilter()" aria-label="select filter input">
              <option value="all">All</option>
              <option value="upcoming">Upcoming</option>
              <option value="past">Past</option>
            </select>
          </div>
        </template>
        <template v-if="filterType === 'category'">
          <div class="w3-col s2">
            <select class="w3-select w3-border" style="height:42px;" v-model="searchOption" @change="$emit('eventSearch', searchOption)">
              <option value="all">View All</option>
              <option value="sporting">Sporting</option>
              <option value="music">Music</option>
              <option value="art">Fine Art</option>
              <option value="vehicle">Cars & Trucks</option>
              <option value="seasonal">Seasonal</option>
            </select>
          </div>
        </template>
        <div class="w3-col s3 m2" v-if="showMapOption">
          <div class="w3-row">
            <div class="w3-col s6">
              <button @click="changeDisplayType('list')" class="w3-button w3-block" :class="displayType === 'list' ? 'w3-green' : 'w3-dark-blue'" style="height:42px;" aria-label="list view button">
                <font-awesome-icon icon="list"></font-awesome-icon>
              </button>
            </div>
            <div class="w3-col s6">
              <button @click="changeDisplayType('map')" class="w3-button w3-block" :class="displayType === 'map' ? 'w3-green' : 'w3-dark-blue'" style="height:42px;" aria-label="map view button">
                <font-awesome-icon icon="map"></font-awesome-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'attractions' || type === 'dining'">
      <div class="w3-row" style="margin:0 4px 8px;">
        <input class="w3-input w3-border" :class="searchText !== '' ? 'activeSearch' : ''" placeholder="Search..." v-model="searchText" @keyup="searchByText()" aria-label="search input" />
        <!-- <div class="w3-col s10">
          <input class="w3-input w3-border" :class="searchText !== '' ? 'activeSearch' : ''" placeholder="Search..." v-model="searchText" @keyup="searchByText()" />
        </div>
        <div class="w3-col s2">
          <select class="w3-select w3-border" v-model="searchOption" @change="setSearchFilter()">
            <option value="all">Category</option>
            <option value="upcoming">Upcoming</option>
            <option value="past">Past</option>
          </select>
        </div> -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'


export default {
  name: 'sortFilter',
  props: ['type','filterType','showMapOption'],
  computed: mapState([
    'events',
    'searchFilter',
    'initSearch'
  ]),
  data() {
    return {
      searchText: '',
      searchOption: 'all',
      displayType: 'list'
    }
  },
  created() {
    if (this.initSearch !== '') {
      this.searchText = this.initSearch
      this.searchByText()
      this.searchText = ''
    }
    this.searchOption = 'all'
    this.setSearchFilter()
  },
  methods: {
    searchByText() {
      let searchVal = this.searchText.trim();
      if (this.type === 'events') {
        this.$store.dispatch('getEvents', searchVal)
      }
      if (this.type === 'attractions') {
        this.$store.dispatch('getPlaces', 'attraction', searchVal)
      }
      if (this.type === 'dining') {
        this.$store.dispatch('getPlaces', 'restaurant', searchVal)
      }
    },
    setSearchFilter() {
      this.$store.commit('setSearchFilter', this.searchOption)
    },
    changeDisplayType(type) {
      this.searchOption = 'all'
      this.setSearchFilter()
      this.displayType = type
      this.$emit('changeDisplayType', type)
    }
  }
}
</script>

<style scoped>
.activeSearch {border-bottom:1pt solid #26a69a !important;}
</style>
